import React from 'react';

const Footer = () => {
  return (
    <div className="form-footer"></div>
  );
};

export default Footer;